import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Stack,
  Flex,
  Text,
  Input,
  Box,
} from "@chakra-ui/react";
import React from "react";
import { BsFacebook, BsApple } from "react-icons/bs";
import { FcGoogle } from "react-icons/fc";
import SignInPopup from "./SignInPopup";
export default function JoinPopup({ children,view,setView }) {
  
  const handleOpen = ()=>{
    setView("sign");
  }
  const handleClose = ()=>{
    setView("");
  }
  return (
    <>
      {children ? (
        <Box onClick={handleOpen} cursor="pointer">{children}</Box>
      ) : (
        <Button colorScheme="brand" size="sm" onClick={handleOpen}>
          Join
        </Button>
      )}
      <Modal isOpen={view} onClose={handleClose} isCentered size="xl" >
        <ModalOverlay />
        <ModalContent pt={6} mx={2} maxHeight="80vh">
          <ModalHeader
            fontSize={{ base: "18px", md: "32px" }}
            fontWeight="semibold"
            align="center"
          >
            Join Decolance
          </ModalHeader>
          <ModalCloseButton
          id="join-close"
            mt={{ base: 8, md: 10 }}
            mr={{ sm: 6 }}
            bg="#c5c5c5"
            color="white"
            borderRadius="20px"
          />
          <ModalBody overflowY="auto" maxHeight="100vh">
            <Stack pt={2} px={{ sm: 12 }} gap={{ base: 2, md: 4 }}>
              <Button borderRadius={10} bg="#4267B2" color="white" py={4}>
                <Flex
                  fontSize={{ base: "14px", md: "17px" }}
                  justifyContent="center"
                  align="center"
                  gap={{ base: 2, md: 8 }}
                >
                  <BsFacebook size="24px" />
                  <Text w={{ base: "160px", sm: "200px" }} align="start">
                    Sign Up with Facebook
                  </Text>
                </Flex>
              </Button>
              <Button
                borderRadius={10}
                bg="white"
                border="1px"
                borderColor="#c5c5c5"
                py={4}
              >
                <Flex
                  fontSize={{ base: "14px", md: "17px" }}
                  justifyContent="center"
                  align="center"
                  gap={{ base: 4, md: 10 }}
                >
                  <FcGoogle size="24px" />
                  <Text w={{ base: "160px", sm: "200px" }} align="start">
                    Sign Up with Google
                  </Text>
                </Flex>
              </Button>
              <Button
                borderRadius={10}
                bg="white"
                border="1px"
                borderColor="#c5c5c5"
                py={4}
              >
                <Flex
                  fontSize={{ base: "14px", md: "17px" }}
                  justifyContent="center"
                  align="center"
                  gap={{ base: 4, md: 10 }}
                >
                  <BsApple size="24px" />
                  <Text w={{ base: "160px", sm: "200px" }} align="start">
                    Sign Up with Apple
                  </Text>
                </Flex>
              </Button>
              <Text
                align="center"
                fontSize={{ base: "18px", md: "23px" }}
                fontWeight="semibold"
              >
                OR
              </Text>
              <Input placeholder="Your Email" py={4} />
              <Button bg="brand.500" color="white" py={4}>
                Continue
              </Button>
            </Stack>
            <Text
              fontSize={{ base: "14px", md: "17px" }}
              py={2}
              align="center"
              mb={4}
              color="#c5c5c5"
            >
              By joining I agree to receive emails from Decolance.
            </Text>
          </ModalBody>

          <ModalFooter
            borderTop="1px"
            borderColor="#c5c5c5"
            flexDirection={"column"}
            gap={2}
          >
            <Text
              align="center"
              color="#727272"
              fontSize="17px"
              fontWeight={"semibold"}
            >
              Already a member?
            </Text>
            <SignInPopup >
            <Text align="center" color="brand.500" textDecoration={"underline"} onClick={()=>{setView("join")}}>
              Sign in
            </Text>
            </SignInPopup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
